/* import __COLOCATED_TEMPLATE__ from './conversation-header-dropdown.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { and, not, readOnly } from '@ember/object/computed';

export default Component.extend({
  classNames: ['u__left'],
  appService: service(),
  app: readOnly('appService.app'),

  notReadOnly: not('readOnly'),

  showAddParticipant: and(
    'isInbox',
    'notReadOnly',
    'app.currentAdminHasInboxAccess',
    'conversation.isNotSocial',
  ),
  showRemoveParticipant: and(
    'isInbox',
    'notReadOnly',
    'conversation.isGroupConversation',
    'app.currentAdminHasInboxAccess',
  ),
});
